export const siteInfo = {
  name: '古古漫画网',
  description: '古古漫画网为您提供终末的女武神等热门漫画在线免费阅读服务，简洁界面快速加载，让您轻松追更最新章节，不错过任何精彩剧情。',
  url: 'https://www.gugumanhua.com',
  email: 'contact@gugumanhua.com',
  address: '北京市朝阳区望京街道10号',
  phone: '400-888-8888',
  year: 2026,
};

export const categories = [
  { id: 'all', name: '全部漫画', icon: 'ri-apps-line' },
  { id: 'hot-blood', name: '热血漫画', icon: 'ri-fire-line' },
  { id: 'fantasy', name: '奇幻漫画', icon: 'ri-magic-line' },
  { id: 'action', name: '动作漫画', icon: 'ri-sword-line' },
  { id: 'comedy', name: '搞笑漫画', icon: 'ri-emotion-laugh-line' },
  { id: 'romance', name: '恋爱漫画', icon: 'ri-heart-line' },
  { id: 'horror', name: '恐怖漫画', icon: 'ri-ghost-line' },
  { id: 'scifi', name: '科幻漫画', icon: 'ri-rocket-line' },
];

export const comics = [
  {
    id: 1,
    title: '终末的女武神',
    author: '梅村真也 / アジチカ / フクイタクミ',
    category: 'hot-blood',
    cover: 'https://readdy.ai/api/search-image?query=Epic%20manga%20cover%20art%20style%2C%20warrior%20goddess%20with%20spear%20facing%20ancient%20fighter%2C%20dramatic%20lighting%20with%20golden%20and%20crimson%20tones%2C%20minimalist%20background%20with%20subtle%20gradient%2C%20Japanese%20comic%20illustration%20style%2C%20clean%20composition&width=800&height=1100&seq=viking-cover-01&orientation=portrait',
    rating: 9.7,
    status: '连载中',
    description: '众神召开会议，决定消灭人类。女武神布伦希尔德提出进行"诸神黄昏"——13场人类对神的决斗。若人类获胜，便可再存活1000年。吕布、亚当、佐佐木小次郎等历史上的强者，将为了人类的存亡而战！',
    chapters: 95,
    views: '1.2亿',
    tags: ['热血', '战斗', '历史', '神话'],
    updateTime: '2026-08-02',
  },
  {
    id: 2,
    title: '咒术回战',
    author: '芥见下下',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%20illustration%2C%20young%20sorcerer%20with%20dark%20hair%20and%20glowing%20fingers%2C%20supernatural%20energy%20surrounding%2C%20dark%20gradient%20background%2C%20Japanese%20comic%20art%20with%20clean%20lines%2C%20minimal%20composition&width=800&height=1100&seq=viking-cover-02&orientation=portrait',
    rating: 9.5,
    status: '连载中',
    description: '高中生虎杖悠仁偶然吞下诅咒之王两面宿傩的手指，由此被卷入诅咒与咒术师的世界，开始了与诅咒战斗的冒险旅程。',
    chapters: 271,
    views: '9800万',
    tags: ['奇幻', '战斗', '校园', '咒术'],
    updateTime: '2026-08-01',
  },
  {
    id: 3,
    title: '海贼王',
    author: '尾田荣一郎',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%2C%20pirate%20captain%20with%20straw%20hat%20grinning%2C%20ocean%20waves%20and%20ship%20in%20background%2C%20warm%20vibrant%20colors%2C%20adventure%20theme%2C%20Japanese%20comic%20illustration%20style%2C%20clean%20minimal%20layout&width=800&height=1100&seq=viking-cover-03&orientation=portrait',
    rating: 9.8,
    status: '连载中',
    description: '蒙奇·D·路飞为了找到传说中的大秘宝ONE PIECE，踏上了成为海贼王的冒险之旅，途中结识了众多伙伴。',
    chapters: 1130,
    views: '2.5亿',
    tags: ['冒险', '热血', '友情', '海贼'],
    updateTime: '2026-08-03',
  },
  {
    id: 4,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%2C%20young%20swordsman%20with%20green%20checkered%20haori%20holding%20katana%2C%20demon%20slayer%20theme%2C%20dark%20night%20background%20with%20moon%2C%20Japanese%20comic%20art%20with%20clean%20composition&width=800&height=1100&seq=viking-cover-04&orientation=portrait',
    rating: 9.6,
    status: '已完结',
    description: '大正时期，少年灶门炭治郎全家被鬼所杀，妹妹祢豆子变成鬼，他为了寻找让妹妹变回人类的方法，踏上了杀鬼之旅。',
    chapters: 205,
    views: '1.8亿',
    tags: ['战斗', '鬼怪', '大正', '兄妹'],
    updateTime: '2026-07-28',
  },
  {
    id: 5,
    title: '排球少年',
    author: '古馆春一',
    category: 'hot-blood',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%20style%2C%20volleyball%20player%20jumping%20to%20spike%20with%20determined%20expression%2C%20orange%20and%20black%20colors%2C%20sports%20gymnasium%20atmosphere%2C%20Japanese%20comic%20illustration%2C%20clean%20minimal%20design&width=800&height=1100&seq=viking-cover-05&orientation=portrait',
    rating: 9.4,
    status: '已完结',
    description: '日向翔阳被"小巨人"的身影所吸引，从此迷上排球。进入乌野高中后，他加入了排球部，开始了热血排球之旅。',
    chapters: 402,
    views: '8500万',
    tags: ['运动', '热血', '排球', '青春'],
    updateTime: '2026-07-25',
  },
  {
    id: 6,
    title: '东京复仇者',
    author: '和久井健',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%2C%20blonde%20delinquent%20youth%20with%20intense%20gaze%2C%20Tokyo%20cityscape%20at%20night%20background%2C%20street%20gang%20theme%2C%20Japanese%20comic%20art%2C%20clean%20composition%20with%20dramatic%20lighting&width=800&height=1100&seq=viking-cover-06&orientation=portrait',
    rating: 9.3,
    status: '已完结',
    description: '花垣武道得知前女友橘日向死亡的消息后，意外获得穿越时空的能力，回到中学时代改变命运。',
    chapters: 278,
    views: '7200万',
    tags: ['穿越', '热血', '不良', '友情'],
    updateTime: '2026-07-20',
  },
  {
    id: 7,
    title: '间谍过家家',
    author: '远藤达哉',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20cover%20art%2C%20family%20of%20three%20with%20spy%20man%2C%20assassin%20woman%2C%20and%20telepathic%20child%20in%20elegant%20clothing%2C%20light%20comedy%20theme%2C%20pastel%20warm%20colors%2C%20Japanese%20comic%20style%2C%20clean%20composition&width=800&height=1100&seq=viking-cover-07&orientation=portrait',
    rating: 9.2,
    status: '连载中',
    description: '为了执行任务，间谍"黄昏"组建了一个虚假家庭，妻子是杀手，女儿是超能力者，三人互相隐藏身份的爆笑日常就此展开。',
    chapters: 105,
    views: '6800万',
    tags: ['搞笑', '间谍', '家庭', '日常'],
    updateTime: '2026-07-30',
  },
  {
    id: 8,
    title: '咒术回战0',
    author: '芥见下下',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Manga%20cover%20style%2C%20young%20man%20with%20cursed%20spirit%20girl%20behind%20him%2C%20supernatural%20dark%20atmosphere%2C%20Japanese%20comic%20art%20with%20clean%20lines%2C%20minimal%20composition%20with%20dramatic%20shadow&width=800&height=1100&seq=viking-cover-08&orientation=portrait',
    rating: 9.4,
    status: '已完结',
    description: '乙骨忧太被青梅竹马的怨灵附体，在五条悟的引导下进入咒术高专，学习控制诅咒之力的故事。',
    chapters: 4,
    views: '4200万',
    tags: ['奇幻', '战斗', '前传', '纯爱'],
    updateTime: '2026-06-15',
  },
];

export const chapters = [
  {
    id: 1,
    comicId: 1,
    title: '第1话：诸神黄昏的开幕',
    number: 1,
    updateTime: '2024-03-15',
    views: '1580万',
    images: [
      'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20page%20style%2C%20gods%20council%20in%20ancient%20Greek%20style%20palace%2C%20dramatic%20panel%20layout%2C%20Japanese%20comic%20art%20with%20clean%20screentones%2C%20cinematic%20composition&width=900&height=1300&seq=chapter-01-p01&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20page%2C%20valkyrie%20woman%20standing%20before%20council%20of%20gods%2C%20defiant%20expression%2C%20Japanese%20comic%20style%20with%20screentones%2C%20clean%20panel%20layout&width=900&height=1300&seq=chapter-01-p02&orientation=portrait',
    ],
    content: '在遥远的天空之上，众神召开了千年一度的会议。会议上，众神一致决定——消灭人类。然而，女武神布伦希尔德站了出来，提出了一个惊人的提议：进行"诸神黄昏"——13场人类与神的代表对决。若人类一方获胜，便可再存活1000年；若神一方获胜，人类将被彻底消灭。',
  },
  {
    id: 2,
    comicId: 1,
    title: '第2话：人类最强之男',
    number: 2,
    updateTime: '2024-03-22',
    views: '1420万',
    images: [
      'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20style%2C%20ancient%20Chinese%20warrior%20on%20horseback%20with%20halberd%2C%20epic%20battlefield%20scene%2C%20Japanese%20comic%20art%20with%20screentones%2C%20dramatic%20panel%20composition&width=900&height=1300&seq=chapter-02-p01&orientation=portrait',
      'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20page%2C%20muscular%20warrior%20facing%20thunder%20god%20in%20arena%2C%20intense%20staredown%2C%20Japanese%20comic%20art%20style%20with%20motion%20lines%2C%20clean%20panels&width=900&height=1300&seq=chapter-02-p02&orientation=portrait',
    ],
    content: '第一场对决的选手是——人类史上最强的战士吕布奉先，对阵北欧神话中的雷神托尔。吕布号称"飞将"，在万军之中无人能敌。面对神的威严，吕布毫无惧色。',
  },
  {
    id: 3,
    comicId: 1,
    title: '第3话：飞将VS雷神',
    number: 3,
    updateTime: '2024-03-29',
    views: '1350万',
    images: [
      'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20art%2C%20epic%20battle%20between%20Chinese%20warrior%20and%20Norse%20thunder%20god%2C%20lightning%20effects%2C%20Japanese%20comic%20style%20with%20screentones%2C%20dynamic%20action%20panels&width=900&height=1300&seq=chapter-03-p01&orientation=portrait',
    ],
    content: '吕布与托尔的战斗正式打响！托尔挥动着巨大的雷神之锤，每一击都伴随着雷鸣电闪，整个竞技场为之震动。吕布则以无双武艺应对，方天画戟舞动如飞，展现出人类最强的战力。',
  },
  {
    id: 4,
    comicId: 1,
    title: '第4话：父亲的对决',
    number: 4,
    updateTime: '2024-04-05',
    views: '1280万',
    images: [
      'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20style%2C%20naked%20man%20with%20fig%20leaf%20standing%20in%20arena%2C%20innocent%20expression%2C%20Japanese%20comic%20art%20with%20screentones%2C%20minimalist%20background%2C%20clean%20panel%20layout&width=900&height=1300&seq=chapter-04-p01&orientation=portrait',
    ],
    content: '第二场对决——人类之父亚当，对阵众神之王宙斯。亚当是史上第一个人类，由神按照自己的形象创造。面对宇宙最强的宙斯，亚当为了守护自己的孩子（全人类）毅然出战。',
  },
  {
    id: 5,
    comicId: 1,
    title: '第5话：神虚视',
    number: 5,
    updateTime: '2024-04-12',
    views: '1220万',
    images: [
      'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20art%2C%20intense%20fistfight%20between%20two%20men%20in%20ancient%20Greek%20arena%2C%20speed%20lines%20and%20impact%20effects%2C%20Japanese%20comic%20style%2C%20dynamic%20action%20panels&width=900&height=1300&seq=chapter-05-p01&orientation=portrait',
    ],
    content: '亚当拥有"神虚视"——可以复制他所看到的一切神技。面对宙斯毁灭性的攻击，亚当一一复制并回击。这场"父亲"之间的对决，让所有观众屏息凝神。',
  },
  {
    id: 6,
    comicId: 1,
    title: '第6话：不败的剑士',
    number: 6,
    updateTime: '2024-04-19',
    views: '1180万',
    images: [
      'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20style%2C%20elderly%20Japanese%20samurai%20with%20katana%2C%20calm%20and%20focused%20expression%2C%20Japanese%20comic%20art%20with%20screentones%2C%20traditional%20dojo%20background%2C%20clean%20composition&width=900&height=1300&seq=chapter-06-p01&orientation=portrait',
    ],
    content: '第三场对决——史上最强剑士佐佐木小次郎，对阵海神波塞冬。小次郎被誉为"不败的剑士"，但历史上的他其实一生都在失败中成长。这一次，他将以毕生所学的剑术，挑战海洋之神。',
  },
  {
    id: 7,
    comicId: 1,
    title: '第7话：千锤百炼',
    number: 7,
    updateTime: '2024-04-26',
    views: '1100万',
    images: [
      'https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20page%2C%20samurai%20facing%20sea%20god%20with%20trident%2C%20water%20and%20sword%20clash%2C%20Japanese%20comic%20art%20with%20screentones%2C%20dramatic%20action%20composition&width=900&height=1300&seq=chapter-07-p01&orientation=portrait',
    ],
    content: '小次郎以"千锤百炼"的剑术对抗波塞冬。他将一生中所有败北与胜利的经验融会贯通，创造出了超越神的剑法。这一刻，人类最强之剑出鞘！',
  },
];

export const faqs = [
  {
    question: '古古漫画网上的漫画都是免费的吗？',
    answer: '是的，古古漫画网上所有漫画内容均免费提供在线阅读，无需付费或订阅。我们致力于为漫画爱好者提供高品质的阅读体验。',
  },
  {
    question: '漫画更新的频率是多少？',
    answer: '热门连载漫画通常每周更新一话，具体更新时间取决于原作的发布进度。您可以在漫画详情页查看最近更新时间。',
  },
  {
    question: '如何快速找到想看的漫画？',
    answer: '您可以通过首页的热门推荐、分类浏览功能，或使用搜索功能输入漫画名称来快速找到目标漫画。网站支持按类型、状态等维度筛选。',
  },
  {
    question: '可以在手机上阅读漫画吗？',
    answer: '当然可以！古古漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备，让您随时随地享受漫画阅读的乐趣。',
  },
  {
    question: '终末的女武神漫画更新到多少话了？',
    answer: '终末的女武神目前已经更新至第95话，剧情正值高潮——人类与神明的对决进入白热化阶段。请关注本站获取最新更新！',
  },
];

export const reviews = [
  {
    id: 1,
    name: '漫画爱好者小明',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20avatar%2C%20friendly%20smile%2C%20simple%20warm%20background%2C%20clean%20studio%20lighting%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '终末的女武神每一话都让我热血沸腾！古古漫画网的加载速度很快，画质清晰，阅读体验非常好。',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '热血漫迷',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20teenager%20portrait%20avatar%2C%20excited%20expression%2C%20simple%20warm%20background%2C%20clean%20studio%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '在这个网站追终末的女武神太爽了！更新及时，界面简洁没有乱七八糟的广告，强烈推荐！',
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20avatar%2C%20gentle%20smile%2C%20simple%20warm%20background%2C%20clean%20studio%20lighting%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 4,
    content: '分类很清晰，找漫画很方便。希望以后能加入更多经典漫画，特别是已完结的神作！',
    date: '2026-07-20',
  },
  {
    id: 4,
    name: '老二次元了',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20avatar%20in%20glasses%2C%20thoughtful%20expression%2C%20simple%20warm%20background%2C%20clean%20studio%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '看了十多年漫画，这个网站的排版和阅读体验确实是用心了的。终末的女武神每一场的战斗设计都太精彩了！',
    date: '2026-07-18',
  },
];

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '分类', path: '/category' },
  { label: '关于我们', path: '/about' },
];